export enum CompensationType {
  VoucherByLetter = 'voucherbyletter',
  ToGoVoucherByEmail = 'togovoucherbyemail',
  BankAccount = 'bankaccount',
}
